import $ from 'jquery';
import Swiper, { Grid, Navigation } from 'swiper';
Swiper.use([ Grid, Navigation ]);

export default class Benefits {
    constructor() {
        if($('.js-benefits').length) {
            const $slider = $('.js-benefits__slider');
            const $slideCount = $('.js-benefits__slide-count');

            const benefits = new Swiper($slider[0], {
                breakpoints: {
                    768: {
                        slidesPerView: 2
                    },
                    1024: {
                        grid: {
                            fill: 'rows',
                            rows: 2
                        },
                        slidesPerGroup: 3,
                        slidesPerView: 3
                    }
                },
                on: {
                    init: function(sw) {
                        let activeIndex = ('0' + (sw.activeIndex + 1)).slice(-2);
                        let length = ('0' + sw.slides.length).slice(-2);

                        $slideCount.text(activeIndex + '/' + length);
                    },
                    slideChangeTransitionEnd: function(sw) {
                        let activeIndex = ('0' + (sw.activeIndex + 1)).slice(-2);
                        let length = ('0' + sw.slides.length).slice(-2);

                        $slideCount.text(activeIndex + '/' + length);
                    }
                },
                navigation: {
                    nextEl: '.js-benefits__nav .swiper-button-next',
                    prevEl: '.js-benefits__nav .swiper-button-prev'
                },
                slidesPerView: 'auto',
                spaceBetween: 20,
                speed: 300
            });

            benefits.init();
        };
    };
};
